export const CLASSES_VALIDATION_RULES = {
  name: {
    isRequiredTrim: {
      value: true,
    },
  },
  classNumber: {
    isRequiredTrim: {
      value: true,
    },
  },
  externalClassNumber: {
    maxLength: {
      value: 16,
    },
  },
  billingPeriodId: {
    isRequiredTrim: {
      value: true,
    },
  },
  divisionId: {
    isRequiredTrim: {
      value: true,
    },
  },
  splitsActiveIn: {
    atLeastOneAcrossMultipleFields: {
      value: {
        field: "isActive",
        expectedValue: true,
        otherFields: ["splitsActiveOut"],
        customMessageKey: "validation.customMessages.noActiveGuarantees",
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/classes/classesValidationRules.js